import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';
import { NotificationTypeSchema } from './read-all';

/**
 * PUT /api/notifications/[id]/read
 * Marks a specific notification as read
 */

// Notification schema for response (supports both Date objects and ISO strings)
export const NotificationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: NotificationTypeSchema,
  title: z.string(),
  message: z.string(),
  actionUrl: z.string().nullable(),
  metadata: z.any(),
  isRead: z.boolean(),
  createdDate: z.union([z.date(), z.string()]),
  readDate: z.union([z.date(), z.string()]).nullable(),
});

export type Notification = z.infer<typeof NotificationSchema>;

// Request parameter schema
export const NotificationMarkReadParamSchema = z.object({
  id: z.string({ error: 'Invalid notification ID' }).min(1, 'Invalid notification ID'),
});

export type NotificationMarkReadParam = z.infer<typeof NotificationMarkReadParamSchema>;

// Success response schema
export const MarkReadSuccessResponseSchema = z.object({
  success: z.literal(true),
  notification: NotificationSchema,
});

export type MarkReadSuccessResponse = z.infer<typeof MarkReadSuccessResponseSchema>;

// Response schema using discriminated union
export const NotificationMarkReadResponseSchema = z.discriminatedUnion('success', [
  MarkReadSuccessResponseSchema,
  ErrorResponseSchema,
]);

export type NotificationMarkReadResponse = z.infer<typeof NotificationMarkReadResponseSchema>;
